import { buildModelManager } from "../builder.js";
const DefaultQaKnowledgeBaseSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  createdById: true,
  institution: true,
  metadata: true,
  name: true,
  openaiVectorStoreId: true,
  status: true,
  updatedAt: true,
  workflowId: true
};
const modelApiIdentifier = "qaKnowledgeBase";
const pluralModelApiIdentifier = "qaKnowledgeBases";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaKnowledgeBaseGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaKnowledgeBaseManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaKnowledgeBaseSelection,
  operations
);
export {
  DefaultQaKnowledgeBaseSelection,
  QaKnowledgeBaseManager
};
//# sourceMappingURL=QaKnowledgeBase.js.map
